import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: true
  },
  {
    path: '/admin-login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/login'),
    props: true,
  },
  {
    path: '/admin-cms',
    name: 'AdminCMS',
    component: () => import('@/views/admin/admin-cms'),
    props: true,
    meta: {private:true}
  },
 // {
   // path: '/about',
    //name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
   // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  //}
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next)=>{
  if(to.meta.private){
    if(store.getters['auth/userIsAuthenticated']){
      next()
    }else{
      // store.commit('auth/SET_ERROR', 'Oops! Parece que no haz iniciado sesion o probablemente tu sesion expiro.')
      next('/admin-login')
    }
  }else{
    next()
  }
})
export default router
